// extracted by mini-css-extract-plugin
export var completionBody = "_mg-2";
export var completionCard = "_mg-0";
export var completionFooter = "_mg-3";
export var completionTitle = "_mg-1";